import { CustomApplicationActions } from "@MasterBluePrint/Store/CustomApplicationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

interface Parameter {
    isCheckoutShippingSubmitting: boolean;
}

type HandlerType = Handler<Parameter, DispatchProp<CustomApplicationActions>>;

export const DispatchSetIsCheckoutShippingSubmitting: HandlerType = props => {
    props.dispatch({
        type: "Components/CustomCheckoutShipping/SetIsCheckoutShippingSubmitting",
        isCheckoutShippingSubmitting: props.parameter.isCheckoutShippingSubmitting,
    });
};

export const chain = [DispatchSetIsCheckoutShippingSubmitting];

const setIsCheckoutShippingSubmitting = createHandlerChainRunner(chain, "SetIsCheckoutShippingSubmitting");
export default setIsCheckoutShippingSubmitting;
